import chatElements from '../config/chatElements';
import { addMessage, askNextQuestion } from '../config/chatUtils';
import { formQuestions, checkAndOfferStoredData } from '../config/chatFormHandling';
import { 
    setCurrentFlow,
    getCurrentFlow,
    setCurrentQuestionIndex,
    getCurrentQuestionIndex,
} from '../config/chatState';

const { chatBody, chatInput } = chatElements;

// Questions with validation functions
const newsletterQuestions = formQuestions('newsletter');

function startNewsletterFlow(first = null) {
    setCurrentFlow('newsletter');
    if (first) {
        addMessage("Sign up for Decisely's business newsletter", 'user', 500);
    }

    const prompted = checkAndOfferStoredData('newsletter', newsletterQuestions);

    if (!prompted) {
        addMessage("Great! Our \"RX For Business Growth\" newsletter is helping businesses like yours 'benefit' better! I just need a few quick details to get you signed up.", 'bot', 1250);
        setCurrentQuestionIndex(0);
        setTimeout(() => askNextQuestion('newsletter'), 1500);
    }
}

export { 
    newsletterQuestions,
    startNewsletterFlow
};